import React, { useState, useEffect, useCallback } from "react";
import './../../App.css';
import './../Maintenance/Maintenance.css';
import { CreateButton, CreateSearchBarWithPlaceHolder } from '../CommonObjects';
import { SetAuditTrail, SetAuditTrailBulk } from './../Reports/AuditTrailReportEmployeeSetup';
import axios from 'axios';
import { CreateTable } from '../ManageTable';
import { token, domain } from '../Security';
import loadingSpinner from './../../assets/loading.gif';
// icon
import SearchIcon from '@mui/icons-material/Search';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function SSS({ user, isHideSideMenu }) {
  var header = [
    "ID",
    "Range From",
    "Range To",
    // "Monthly Salary",
    "SSS ER",
    "MPF ER",
    "ECER",
    "Total Contribution ER",
    "SSS EE",
    "MPF EE",
    "Total Contribution EE",
    "SSS Total",
    // "Total Contribution Total",
    // "SE Total Contribution",
    "",
  ]
  var accessor = [
    "id",
    "rangeFrom",
    "rangeTo",
    // "monthlySalary",
    "ssser",
    "mpfer",
    "ecer",
    "totalContributionER",
    "sssee",
    "mpfee",
    "totalContributionEE",
    // "totalContributionTotal",
    // "seTotalContribution",
    "sssTotal",
    "manage"
  ]

  const [currentPage, setCurrentPage] = useState(1);

  const [loading, setLoading] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [sss, setSSS] = useState([]);
  // Retrieve
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("----Select filter----");
  // Add
  const [showAddForm, setShowAddForm] = useState(false);
  const [rangeFrom, setRangeFrom] = useState("");
  const [rangeTo, setRangeTo] = useState("");
  const [monthlySalary, setMonthlySalary] = useState("");
  const [ssser, setssser] = useState("");
  const [sssee, setsssee] = useState("");
  const [mpfee, setmpfee] = useState("");
  const [mpfer, setmpfer] = useState("");
  const [sssTotal, setsssTotal] = useState("");
  const [ecer, setecer] = useState("");
  const [totalContributionER, setTotalContributionER] = useState("");
  const [totalContributionEE, setTotalContributionEE] = useState("");
  const [totalContributionTotal, setTotalContributionTotal] = useState("");
  const [seTotalContribution, setseTotalContribution] = useState("");
  // Update
  const [showEditForm, setShowEditForm] = useState(false);
  const [editById, setEditById] = useState("");
  const [editRangeFrom, setEditRangeFrom] = useState("");
  const [editRangeTo, setEditRangeTo] = useState("");
  const [editMonthlySalary, setEditMonthlySalary] = useState("");
  const [editssser, setEditssser] = useState("");
  const [editsssee, setEditsssee] = useState("");
  const [editmpfee, setEditmpfee] = useState("");
  const [editmpfer, setEditmpfer] = useState("");
  const [editsssTotal, setEditsssTotal] = useState("");
  const [editecer, setEditecer] = useState("");
  const [editTotalContributionER, setEditTotalContributionER] = useState("");
  const [editTotalContributionEE, setEditTotalContributionEE] = useState("");
  const [editTotalContributionTotal, setEditTotalContributionTotal] = useState("");
  const [editseTotalContribution, setEditseTotalContribution] = useState("");
  //old
  const [oldEditRangeFrom, setOldEditRangeFrom] = useState("");
  const [oldEditRangeTo, setOldEditRangeTo] = useState("");
  const [oldEditMonthlySalary, setOldEditMonthlySalary] = useState("");
  const [oldEditssser, setOldEditssser] = useState("");
  const [oldEditsssee, setOldEditsssee] = useState("");
  const [oldEditmpfee, setOldEditmpfee] = useState("");
  const [oldEditmpfer, setOldEditmpfer] = useState("");
  const [oldEditsssTotal, setOldEditsssTotal] = useState("");
  const [oldEditecer, setOldEditecer] = useState("");
  const [oldEditTotalContributionER, setOldEditTotalContributionER] = useState("");
  const [oldEditTotalContributionEE, setOldEditTotalContributionEE] = useState("");
  const [oldEditTotalContributionTotal, setOldEditTotalContributionTotal] = useState("");
  const [oldEditseTotalContribution, setOldEditseTotalContribution] = useState("");
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }

  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
          {form && (
            <div className="modal toggleMessage" style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}>
              <div className='column'>
                {isSuccess ?
                  <div className='request_title row' style={{ fontWeight: "bold", color: "green", alignItems: "center" }}>
                    <CheckCircleIcon />
                    <span >{"SUCCESS MESSAGE"}</span>
                  </div>
                  :
                  <div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                }
                <span style={{ textAlign: "center", padding: "10px 0", color: isSuccess ? "green" : "#DD5746" }}>{message}</span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const apiUrl = domain + "/api/SSS";

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      setSSS(response.data); // Set the response data to the state
      setFilterData(response.data); // Set the response data to the state
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchData();
    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("----Select filter----")
        break;
      case 1:
        setSearchPlaceholder("Search by sss id")
        break;
      default:
        setSearchPlaceholder("----Select filter----")
        break;
    }
  }, [fetchData, filterDataIndex]);

  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        return;
      case 1:
        res = filterData.filter((f) =>
          f.id.toString().startsWith(lowercaseValue)
        );
        break;
      default:
        break;
    }

    setSSS(res);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    const data = {
      rangeFrom: rangeFrom,
      rangeTo: rangeTo,
      monthlySalary: monthlySalary,
      ssser: ssser,
      sssee: sssee,
      mpfee: mpfee,
      mpfer: mpfer,
      sssTotal: sssTotal,
      ecer: ecer,
      totalContributionER: totalContributionER,
      totalContributionEE: totalContributionEE,
      totalContributionTotal: totalContributionTotal,
      seTotalContribution: seTotalContribution,
    };

    try {
      setLoadingRequest(true);
      await axios.post(apiUrl, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      setShowAddForm(false); // Hide the add form
      await SetAuditTrail({
        setupArea: "SSS",
        actionTaken: "insert",
        field: "Add",
        newValue: `-`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });

      await fetchData(); // Assuming fetchData() fetches the updated data for the table

      console.log('Data added successfully');
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset form fields
      setRangeFrom("");
      setRangeTo("");
      setMonthlySalary("");
      setssser("");
      setsssee("");
      setmpfee("");
      setmpfer("");
      setsssTotal("");
      setecer("");
      setTotalContributionER("");
      setTotalContributionEE("");
      setTotalContributionTotal("");
      setseTotalContribution("");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowAddForm(false);
  };
  const handleUpdate = async (event) => {
    event.preventDefault();

    const data = {
      rangeFrom: editRangeFrom,
      rangeTo: editRangeTo,
      monthlySalary: editMonthlySalary,
      ssser: editssser,
      sssee: editsssee,
      mpfee: editmpfee,
      mpfer: editmpfer,
      sssTotal: editsssTotal,
      ecer: editecer,
      totalContributionER: editTotalContributionER,
      totalContributionEE: editTotalContributionEE,
      totalContributionTotal: editTotalContributionTotal,
      seTotalContribution: editseTotalContribution,
    };

    try {
      setLoadingRequest(true);
      await axios.put(apiUrl + `/${editById}`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      let auditInfo = [];

      if (data.rangeFrom !== oldEditRangeFrom) {
        auditInfo.push({
          setupArea: "SSS",
          actionTaken: "update",
          field: "Range From",
          newValue: `${data.rangeFrom}`,
          oldValue: `${oldEditRangeFrom}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.rangeTo !== oldEditRangeTo) {
        auditInfo.push({
          setupArea: "SSS",
          actionTaken: "update",
          field: "Range To",
          newValue: `${data.rangeTo}`,
          oldValue: `${oldEditRangeTo}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.monthlySalary !== oldEditMonthlySalary) {
        auditInfo.push({
          setupArea: "SSS",
          actionTaken: "update",
          field: "Monthly Salary",
          newValue: `${data.monthlySalary}`,
          oldValue: `${oldEditMonthlySalary}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.ssser !== oldEditssser) {
        auditInfo.push({
          setupArea: "SSS",
          actionTaken: "update",
          field: "SSS ER",
          newValue: `${data.ssser}`,
          oldValue: `${oldEditssser}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.sssee !== oldEditsssee) {
        auditInfo.push({
          setupArea: "SSS",
          actionTaken: "update",
          field: "SSS EE",
          newValue: `${data.sssee}`,
          oldValue: `${oldEditsssee}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.mpfee !== oldEditmpfee) {
        auditInfo.push({
          setupArea: "SSS",
          actionTaken: "update",
          field: "MPF EE",
          newValue: `${data.mpfee}`,
          oldValue: `${oldEditmpfee}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.mpfer !== oldEditmpfer) {
        auditInfo.push({
          setupArea: "SSS",
          actionTaken: "update",
          field: "MPF ER",
          newValue: `${data.mpfer}`,
          oldValue: `${oldEditmpfer}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.sssTotal !== oldEditsssTotal) {
        auditInfo.push({
          setupArea: "SSS",
          actionTaken: "update",
          field: "SSS Total",
          newValue: `${data.sssTotal}`,
          oldValue: `${oldEditsssTotal}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.ecer !== oldEditecer) {
        auditInfo.push({
          setupArea: "SSS",
          actionTaken: "update",
          field: "ECER",
          newValue: `${data.ecer}`,
          oldValue: `${oldEditecer}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.totalContributionER !== oldEditTotalContributionER) {
        auditInfo.push({
          setupArea: "SSS",
          actionTaken: "update",
          field: "Total Contribution ER",
          newValue: `${data.totalContributionER}`,
          oldValue: `${oldEditTotalContributionER}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.totalContributionEE !== oldEditTotalContributionEE) {
        auditInfo.push({
          setupArea: "SSS",
          actionTaken: "update",
          field: "Total Contribution EE",
          newValue: `${data.totalContributionEE}`,
          oldValue: `${oldEditTotalContributionEE}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.totalContributionTotal !== oldEditTotalContributionTotal) {
        auditInfo.push({
          setupArea: "SSS",
          actionTaken: "update",
          field: "Total Contribution",
          newValue: `${data.totalContributionTotal}`,
          oldValue: `${oldEditTotalContributionTotal}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.seTotalContribution !== oldEditseTotalContribution) {
        auditInfo.push({
          setupArea: "SSS",
          actionTaken: "update",
          field: "SE Total Contribution",
          newValue: `${data.seTotalContribution}`,
          oldValue: `${oldEditseTotalContribution}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      setShowEditForm(false);
      await SetAuditTrailBulk({ data: auditInfo });
      await fetchData(); // Assuming fetchData() fetches the updated data for the table

      console.log('Data updated successfully');
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset form fields
      setEditRangeFrom("");
      setEditRangeTo("");
      setEditMonthlySalary("");
      setEditssser("");
      setEditsssee("");
      setEditmpfee("");
      setEditmpfer("");
      setEditsssTotal("");
      setEditecer("");
      setEditTotalContributionER("");
      setEditTotalContributionEE("");
      setEditTotalContributionTotal("");
      setEditseTotalContribution("");
      setEditById("");
    } catch (error) {
      console.error('There was a problem updating data:', error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowEditForm(false);
  };

  const addHandleClick = () => {
    setShowAddForm(true);
  };
  const editHandleClick = (data) => {
    setEditById(data.id);
    setEditRangeFrom(data.rangeFrom);
    setEditRangeTo(data.rangeTo);
    setEditMonthlySalary(data.monthlySalary);
    setEditssser(data.ssser);
    setEditsssee(data.sssee);
    setEditmpfee(data.mpfee);
    setEditmpfer(data.mpfer);
    setEditsssTotal(data.sssTotal);
    setEditecer(data.ecer);
    setEditTotalContributionER(data.totalContributionER);
    setEditTotalContributionEE(data.totalContributionEE);
    setEditTotalContributionTotal(data.totalContributionTotal);
    setEditseTotalContribution(data.seTotalContribution);

    setOldEditRangeFrom(data.rangeFrom);
    setOldEditRangeTo(data.rangeTo);
    setOldEditMonthlySalary(data.monthlySalary);
    setOldEditssser(data.ssser);
    setOldEditsssee(data.sssee);
    setOldEditmpfee(data.mpfee);
    setOldEditmpfer(data.mpfer);
    setOldEditsssTotal(data.sssTotal);
    setOldEditecer(data.ecer);
    setOldEditTotalContributionER(data.totalContributionER);
    setOldEditTotalContributionEE(data.totalContributionEE);
    setOldEditTotalContributionTotal(data.totalContributionTotal);
    setOldEditseTotalContribution(data.seTotalContribution);

    setShowEditForm(true);
  };
  const closeAddHandleClick = () => {
    setShowAddForm(false);
  };
  const closeEditHandleClick = () => {
    setShowEditForm(false);
  };

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl">
            <div className="mainteHeader">
              <div className='sub-title row'>
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Government Premiums >"} </span>
                <span style={{ borderBottom: "1px solid black" }}>{"SSS"}</span>
              </div>
              <h3>SSS</h3>
            </div>
            <div className="mainte-body">
              {Filter(setFilterDataIndex)}
              <div className="mainte-body-top row">
                {CreateSearchBarWithPlaceHolder("", "mainte-search row", "mainte-search-icon", "mainte-search-input", (e) => handleFilter(e.target.value), searchPlaceholder, SearchIcon)}
                <div className="mainte-addBtn row">
                  {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                </div>
              </div>
              <div className="maintenance-table container">
                <CreateTable
                  dataList={sss}
                  dataHeader={header}
                  dataAccessor={accessor}
                  editHandleClick={editHandleClick}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddForm isOpen={showAddForm}
        onClose={closeAddHandleClick}
        rangeFrom={rangeFrom}
        rangeTo={rangeTo}
        monthlySalary={monthlySalary}
        ssser={ssser}
        sssee={sssee}
        mpfee={mpfee}
        mpfer={mpfer}
        sssTotal={sssTotal}
        ecer={ecer}
        totalContributionER={totalContributionER}
        totalContributionEE={totalContributionEE}
        totalContributionTotal={totalContributionTotal}
        seTotalContribution={seTotalContribution}
        setRangeFrom={setRangeFrom}
        setRangeTo={setRangeTo}
        setMonthlySalary={setMonthlySalary}
        setssser={setssser}
        setsssee={setsssee}
        setmpfee={setmpfee}
        setmpfer={setmpfer}
        setsssTotal={setsssTotal}
        setecer={setecer}
        setTotalContributionER={setTotalContributionER}
        setTotalContributionEE={setTotalContributionEE}
        setTotalContributionTotal={setTotalContributionTotal}
        setseTotalContribution={setseTotalContribution}
        handleSubmit={handleSubmit}
      >
      </AddForm>
      <EditForm isOpen={showEditForm}
        onClose={closeEditHandleClick}
        editRangeFrom={editRangeFrom}
        editRangeTo={editRangeTo}
        editMonthlySalary={editMonthlySalary}
        editssser={editssser}
        editsssee={editsssee}
        editmpfee={editmpfee}
        editmpfer={editmpfer}
        editsssTotal={editsssTotal}
        editecer={editecer}
        editTotalContributionER={editTotalContributionER}
        editTotalContributionEE={editTotalContributionEE}
        editTotalContributionTotal={editTotalContributionTotal}
        editseTotalContribution={editseTotalContribution}
        setEditRangeFrom={setEditRangeFrom}
        setEditRangeTo={setEditRangeTo}
        setEditMonthlySalary={setEditMonthlySalary}
        setEditssser={setEditssser}
        setEditsssee={setEditsssee}
        setEditmpfee={setEditmpfee}
        setEditmpfer={setEditmpfer}
        setEditsssTotal={setEditsssTotal}
        setEditecer={setEditecer}
        setEditTotalContributionER={setEditTotalContributionER}
        setEditTotalContributionEE={setEditTotalContributionEE}
        setEditTotalContributionTotal={setEditTotalContributionTotal}
        setEditseTotalContribution={setEditseTotalContribution}
        handleUpdate={handleUpdate}
      >
      </EditForm>
      <GenerateMessage form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      >
      </GenerateMessage>
      {loadingRequest || loading ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )
      }
    </div>
  )
}
function AddForm({ isOpen,
  onClose,
  rangeFrom,
  rangeTo,
  monthlySalary,
  ssser,
  sssee,
  mpfee,
  mpfer,
  sssTotal,
  ecer,
  totalContributionER,
  totalContributionEE,
  totalContributionTotal,
  seTotalContribution,
  setRangeFrom,
  setRangeTo,
  setMonthlySalary,
  setssser,
  setsssee,
  setmpfee,
  setmpfer,
  setsssTotal,
  setecer,
  setTotalContributionER,
  setTotalContributionEE,
  setTotalContributionTotal,
  setseTotalContribution,
  handleSubmit }) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (!rangeFrom
      || !rangeTo
      // || !monthlySalary
      || !ssser
      || !sssee
      || !mpfee
      || !mpfer
      || !sssTotal
      || !ecer
      || !totalContributionER
      || !totalContributionEE
      // || !totalContributionTotal
      // || !seTotalContribution
    ) {
      setErrorState(true);
      return;
    }
    handleSubmit(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setRangeFrom("");
    setRangeTo("");
    setMonthlySalary("");
    setssser("");
    setsssee("");
    setmpfee("");
    setmpfer("");
    setsssTotal("");
    setecer("");
    setTotalContributionER("");
    setTotalContributionEE("");
    setTotalContributionTotal("");
    setseTotalContribution("");
    setErrorState(false);
  };

  useEffect(() => {
    const _sssTotal = Number(ssser)
      + Number(sssee)
      + Number(ecer)
      + Number(mpfee)
      + Number(mpfer)
    setsssTotal(_sssTotal)
  }, [ssser, sssee, ecer, setsssTotal, mpfee, mpfer])

  useEffect(() => {
    const _totalContributionER = Number(ssser)
      + Number(ecer)
      + Number(mpfer)
    setTotalContributionER(_totalContributionER)
  }, [ssser, ecer, mpfer, setTotalContributionER])

  useEffect(() => {
    const _totalContributionEE = Number(sssee)
      + Number(mpfee)
    setTotalContributionEE(_totalContributionEE)
  }, [sssee, mpfee, setTotalContributionEE])

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Add SSS</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="space-y-4 md:col-span-2 mt-2 bg-[#668fca]/60 p-[1px] px-2">
                <h3 className="text-xs font-bold uppercase tracking-wider text-white border-b">Basic Details</h3>
              </div>

              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Range From</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="rangeFrom"
                      placeholder="Range From"
                      value={rangeFrom}
                      onChange={(e) => setRangeFrom(e.target.value)}
                    />
                  </div>
                  <span style={{
                    visibility: !rangeFrom && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Range To</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="rangeTo"
                      placeholder="Range To"
                      value={rangeTo}
                      onChange={(e) => setRangeTo(e.target.value)}
                    />
                  </div>
                  <span style={{
                    visibility: !rangeTo && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              </div>

              <div className="space-y-4 md:col-span-2 mt-2 bg-[#668fca]/60 p-[1px] px-2">
                <h3 className="text-xs font-bold uppercase tracking-wider text-white border-b">Employer</h3>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column hidden">
                  <div className="info-item-label">Monthly Salary</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="monthlySalary"
                      placeholder="Monthly Salary"
                      value={monthlySalary}
                      onChange={(e) => setMonthlySalary(e.target.value)}
                    />
                  </div>
                  <span style={{
                    visibility: !monthlySalary && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">SSS ER</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="ssser"
                      placeholder="SSS ER"
                      value={ssser}
                      onChange={(e) => setssser(e.target.value)}
                    />
                  </div>
                  <span style={{
                    visibility: !ssser && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">MPF ER</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="mpfer"
                      placeholder="MPF ER"
                      value={mpfer}
                      onChange={(e) => setmpfer(e.target.value)}
                    />
                  </div>
                  <span style={{
                    visibility: !mpfer && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">ECER</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="ecer"
                      placeholder="ECER"
                      value={ecer}
                      onChange={(e) => setecer(e.target.value)}
                    />
                  </div>
                  <span style={{
                    visibility: !ecer && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                </div>
              </div>
              <div className="space-y-4 md:col-span-2 mt-2 bg-[#668fca]/60 p-[1px] px-2">
                <h3 className="text-xs font-bold uppercase tracking-wider text-white border-b">Employee</h3>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">SSS EE</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="sssee"
                      placeholder="SSS EE"
                      value={sssee}
                      onChange={(e) => setsssee(e.target.value)}
                    />
                  </div>
                  <span style={{
                    visibility: !sssee && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">MPF EE</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="mpfee"
                      placeholder="MPF EE"
                      value={mpfee}
                      onChange={(e) => setmpfee(e.target.value)}
                    />
                  </div>
                  <span style={{
                    visibility: !mpfee && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              </div>


              <div className="space-y-4 md:col-span-2 mt-2 bg-[#668fca]/60 p-[1px] px-2">
                <h3 className="text-xs font-bold uppercase tracking-wider text-white border-b">Totals</h3>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Contribution ER</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="totalContributionER"
                      placeholder="Total Contribution ER"
                      value={totalContributionER}
                      onChange={(e) => setTotalContributionER(e.target.value)}
                      readOnly
                      className="cursor-not-allowed bg-gray-200"
                    />
                  </div>
                  <span style={{
                    visibility: !totalContributionER && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Contribution EE</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="totalContributionEE"
                      placeholder="Total Contribution EE"
                      value={totalContributionEE}
                      onChange={(e) => setTotalContributionEE(e.target.value)}
                      readOnly
                      className="cursor-not-allowed bg-gray-200"
                    />
                  </div>
                  <span style={{
                    visibility: !totalContributionEE && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">SSS Total</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="sssTotal"
                      placeholder="SSS Total"
                      value={sssTotal}
                      onChange={(e) => setsssTotal(e.target.value)}
                      readOnly
                      className="cursor-not-allowed bg-gray-200"
                    />
                  </div>
                  <span style={{
                    visibility: !sssTotal && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                </div>
              </div>
              <div className="info-item-holder row hidden">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Contribution</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="totalContributionTotal"
                      placeholder="Total Contribution"
                      value={totalContributionTotal}
                      onChange={(e) => setTotalContributionTotal(e.target.value)}
                      readOnly
                      className="cursor-not-allowed bg-gray-200"
                    />
                  </div>
                  <span style={{
                    visibility: !totalContributionTotal && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">SE Total Contribution</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="seTotalContribution"
                      placeholder="SE Total Contribution"
                      value={seTotalContribution}
                      onChange={(e) => setseTotalContribution(e.target.value)}
                      readOnly
                      className="cursor-not-allowed bg-gray-200"
                    />
                  </div>
                  <span style={{
                    visibility: !seTotalContribution && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={(e) => submit(e)}>
                SAVE
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EditForm({ isOpen,
  onClose,
  editRangeFrom,
  editRangeTo,
  editMonthlySalary,
  editssser,
  editsssee,
  editmpfee,
  editmpfer,
  editsssTotal,
  editecer,
  editTotalContributionER,
  editTotalContributionEE,
  editTotalContributionTotal,
  editseTotalContribution,
  setEditRangeFrom,
  setEditRangeTo,
  setEditMonthlySalary,
  setEditssser,
  setEditsssee,
  setEditmpfee,
  setEditmpfer,
  setEditsssTotal,
  setEditecer,
  setEditTotalContributionER,
  setEditTotalContributionEE,
  setEditTotalContributionTotal,
  setEditseTotalContribution,
  handleUpdate }) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (editRangeFrom === ""
      || editRangeTo === ""
      // || editMonthlySalary === ""
      || editssser === ""
      || editsssee === ""
      || editmpfee === ""
      || editmpfer === ""
      || editsssTotal === ""
      || editecer === ""
      || editTotalContributionER === ""
      || editTotalContributionEE === ""
      || editTotalContributionTotal === ""
      || editseTotalContribution === ""
    ) {
      setErrorState(true);
      return;
    }
    handleUpdate(e);
    setErrorState(false);
  };
  const handleClose = () => {
    onClose();
    setErrorState(false);
  };

  useEffect(() => {
    const _sssTotal = Number(editssser)
      + Number(editsssee)
      + Number(editecer)
      + Number(editmpfee)
      + Number(editmpfer)
    setEditsssTotal(_sssTotal)
  }, [editssser, editsssee, editecer, setEditsssTotal, editmpfee, editmpfer])

  useEffect(() => {
    const _totalContributionER = Number(editssser)
      + Number(editecer)
      + Number(editmpfer)
    setEditTotalContributionER(_totalContributionER)
  }, [editssser, editecer, editmpfer, setEditTotalContributionER])

  useEffect(() => {
    const _totalContributionEE = Number(editsssee)
      + Number(editmpfee)
    setEditTotalContributionEE(_totalContributionEE)
  }, [editsssee, editmpfee, setEditTotalContributionEE])

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update SSS</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="space-y-4 md:col-span-2 mt-2 bg-[#668fca]/60 p-[1px] px-2">
                <h3 className="text-xs font-bold uppercase tracking-wider text-white border-b">Basic Details</h3>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Range From</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="editRangeFrom"
                      placeholder="Range From"
                      value={editRangeFrom}
                      onChange={(e) => setEditRangeFrom(e.target.value)}
                    />
                  </div>
                  <span style={{
                    visibility: editRangeFrom === "" && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Range To</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="editRangeTo"
                      placeholder="Range To"
                      value={editRangeTo}
                      onChange={(e) => setEditRangeTo(e.target.value)}
                    />
                  </div>
                  <span style={{
                    visibility: editRangeTo === "" && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              </div>


              <div className="space-y-4 md:col-span-2 mt-2 bg-[#668fca]/60 p-[1px] px-2">
                <h3 className="text-xs font-bold uppercase tracking-wider text-white border-b">Employer</h3>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column hidden">
                  <div className="info-item-label">Monthly Salary</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="editMonthlySalary"
                      placeholder="Monthly Salary"
                      value={editMonthlySalary}
                      onChange={(e) => setEditMonthlySalary(e.target.value)}
                    />
                  </div>
                  <span style={{
                    visibility: editMonthlySalary === "" && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">SSS ER</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="editssser"
                      placeholder="SSS ER"
                      value={editssser}
                      onChange={(e) => setEditssser(e.target.value)}
                    />
                  </div>
                  <span style={{
                    visibility: editssser === "" && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">MPF ER</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="editmpfer"
                      placeholder="MPF ER"
                      value={editmpfer}
                      onChange={(e) => setEditmpfer(e.target.value)}
                    />
                  </div>
                  <span style={{
                    visibility: editmpfer === "" && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">ECER</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="editecer"
                      placeholder="ECER"
                      value={editecer}
                      onChange={(e) => setEditecer(e.target.value)}
                    />
                  </div>
                  <span style={{
                    visibility: editecer === "" && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                </div>
              </div>

              <div className="space-y-4 md:col-span-2 mt-2 bg-[#668fca]/60 p-[1px] px-2">
                <h3 className="text-xs font-bold uppercase tracking-wider text-white border-b">Employee</h3>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">SSS EE</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="editsssee"
                      placeholder="SSS EE"
                      value={editsssee}
                      onChange={(e) => setEditsssee(e.target.value)}
                    />
                  </div>
                  <span style={{
                    visibility: editsssee === "" && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">MPF EE</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="editmpfee"
                      placeholder="MPF EE"
                      value={editmpfee}
                      onChange={(e) => setEditmpfee(e.target.value)}
                    />
                  </div>
                  <span style={{
                    visibility: editmpfee === "" && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              </div>

              <div className="space-y-4 md:col-span-2 mt-2 bg-[#668fca]/60 p-[1px] px-2">
                <h3 className="text-xs font-bold uppercase tracking-wider text-white border-b">Totals</h3>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Contribution ER</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="editTotalContributionER"
                      placeholder="Total Contribution ER"
                      value={editTotalContributionER}
                      onChange={(e) => setEditTotalContributionER(e.target.value)}
                      readOnly
                      className="cursor-not-allowed bg-gray-200"
                    />
                  </div>
                  <span style={{
                    visibility: editTotalContributionER === "" && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Contribution EE</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="editTotalContributionEE"
                      placeholder="Total Contribution EE"
                      value={editTotalContributionEE}
                      onChange={(e) => setEditTotalContributionEE(e.target.value)}
                      readOnly
                      className="cursor-not-allowed bg-gray-200"
                    />
                  </div>
                  <span style={{
                    visibility: editTotalContributionEE === "" && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">SSS Total</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="editsssTotal"
                      placeholder="SSS Total"
                      value={editsssTotal}
                      onChange={(e) => setEditsssTotal(e.target.value)}
                      readOnly
                      className="cursor-not-allowed bg-gray-200"
                    />
                  </div>
                  <span style={{
                    visibility: editsssTotal === "" && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                </div>
              </div>
              <div className="info-item-holder row hidden">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Contribution</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="editTotalContributionTotal"
                      placeholder="Total Contribution"
                      value={editTotalContributionTotal}
                      onChange={(e) => setEditTotalContributionTotal(e.target.value)}
                      readOnly
                      className="cursor-not-allowed bg-gray-200"
                    />
                  </div>
                  <span style={{
                    visibility: editTotalContributionTotal === "" && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">SE Total Contribution</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="editseTotalContribution"
                      placeholder="SE Total Contribution"
                      value={editseTotalContribution}
                      onChange={(e) => setEditseTotalContribution(e.target.value)}
                      readOnly
                      className="cursor-not-allowed bg-gray-200"
                    />
                  </div>
                  <span style={{
                    visibility: editseTotalContribution === "" && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={(e) => submit(e)}>
                UPDATE
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function Filter(setFilterDataIndex) {
  const [selectedOption, setSelectedOption] = useState('');

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "SSSId":
        setFilterDataIndex(1);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <div className="filters row" style={{ alignItems: "center" }}>
      <span style={{ marginRight: "10px" }}>Filter</span>
      <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
        <option value="All">All</option>
        <option value="SSSId">SSS Id</option>
      </select>
    </div>
  );
};
export default SSS